import { render } from "./TooltipContent.vue?vue&type=template&id=49be79d0&ts=true"
import script from "./TooltipContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./TooltipContent.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/tooltip/TooltipContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "49be79d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('49be79d0', __exports__)) {
    api.reload('49be79d0', __exports__)
  }
  
  module.hot.accept("./TooltipContent.vue?vue&type=template&id=49be79d0&ts=true", () => {
    api.rerender('49be79d0', render)
  })

}


export default __exports__